module.exports = __webpack_public_path__ + "img/chat_bot.1ce00fc.svg";